module.exports = __webpack_public_path__ + "fonts/StagSans-Book.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Book.otf
// module id = 1087
// module chunks = 0